import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  gameSuggestionCard: {
    background: theme.colors.background6,
    borderRadius: theme.radius.medium,
    padding: theme.spacing.space12,
    gap: theme.spacing.space12,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    width: "100%",
    "@media (orientation: landscape)": {
      width: "70%",
    },
  },
  title: {},
}));
